<template lang="pug">
.user-search-form-field
  v-container
    v-layout(justify-space-between)
      v-flex(
        xs5
        md7)
        v-select(
          v-model="key"
          :items="TYPES"
          :error-messages="keyErrors"
          item-value="value"
          item-text="text"
          label="搜尋項目*"
          outline
          @input="$v.key.$touch()"
          @blur="$v.key.$touch()")
      v-flex(
        xs5
        md3)
        v-text-field(
          v-if="!!key && ['birthM', 'region'].indexOf(key) === -1"
          v-model="value"
          :error-messages="valueErrors"
          label="條件*"
          outline
          required
          @input="$v.value.$touch()"
          @blur="$v.value.$touch()")
        v-select(
          v-if="key === 'birthM'"
          v-model="value"
          :items="monthItems"
          :error-messages="valueErrors"
          item-value="value"
          item-text="text"
          label="生日月份*"
          outline
          @input="$v.value.$touch()"
          @blur="$v.value.$touch()")
        v-select(
          v-if="key === 'region'"
          v-model="value"
          :items="regionItems"
          :error-messages="valueErrors"
          item-value="value"
          item-text="text"
          label="區域*"
          outline
          @input="$v.value.$touch()"
          @blur="$v.value.$touch()")
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import REGIONS from "@/assets/tables/regions.json";

const TYPES = [
  { value: "displayName", text: "姓名" },
  { value: "phoneNumber", text: "電話" },
  { value: "birthM", text: "生日月份" },
  { value: "region", text: "區域" }
];

let monthItems = [];

for (let month = 1; month <= 12; month += 1) {
  monthItems.push({ value: month, text: `${month}月` });
}

export default {
  name: "UserSearchForm",
  mixins: [validationMixin],
  validations: {
    key: { required },
    value: { required }
  },
  data() {
    return {
      TYPES,
      monthItems,
      regionItems: Object.entries(REGIONS).map(v => v[1]),
      key: null,
      value: null
    };
  },
  computed: {
    keyErrors() {
      const errors = [];
      if (!this.$v.key.$dirty) return errors;
      !this.$v.key.required && errors.push("請選擇搜尋項目");
      return errors;
    },
    valueErrors() {
      const errors = [];
      if (!this.$v.value.$dirty) return errors;
      !this.$v.value.required && errors.push("請輸入搜尋條件");
      return errors;
    }
  },
  methods: {
    submit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return false;
      }

      return { key: this.key, value: this.value };
    }
  }
};
</script>
